// Polskie słowniki
export { getDictionary } from './getDictionary' // Server-side
export { useDict } from './useDict' // Client-side
